import { MaxWidth } from "shared/components/MaxWidth";
import { Page } from "clariah/components/Page";
import { Pagination } from "shared/components/Pagination";
import { SMALL } from "shared/utils/constants";
import { SEARCH_RESULTS_PER_PAGE } from "clariah/utils/constants";
import {
  SEARCH_RESULTS_FOUND_FOR,
  SEARCH_TITLE,
  translate,
} from "shared/utils/translate";
import { SearchInput } from "clariah/components/SearchInput";
import { SearchResultContainer } from "clariah/components/SearchResultContainer";
import { SearchResultItem } from "clariah/components/SearchResultItem";
import { Spacing } from "shared/components/Spacing";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useSearch } from "clariah/utils/useSearch";

export const SearchPage = ({ footer, mirrorPath, navigation }) => {
  const router = useRouter();

  const [query, setQuery] = useState(router.query.q || "");
  const results = useSearch(query, router.locale);

  useEffect(() => {
    const { q } = router.query;

    if (q && q !== "") {
      setQuery(q);
    }
  }, [router.query.q]);

  useEffect(() => {
    router.replace({
      pathname: router.pathname,
      locale: router.locale,
      query: {
        page: 1,
        q: query,
      },
    });
  }, [query]);

  const pageStart = +router.query.page - 1 || 0;
  const pageEnd = +router.query.page || 1;
  const postStart = SEARCH_RESULTS_PER_PAGE * pageStart;
  const postEnd = SEARCH_RESULTS_PER_PAGE * pageEnd;

  const resultsForPage = results.slice(postStart, postEnd);

  return (
    <Page
      description={`${translate(SEARCH_RESULTS_FOUND_FOR, router.locale)} ${
        router.query.q
      }`}
      footer={footer}
      mirrorPath={mirrorPath}
      navigation={navigation}
      title={translate(SEARCH_TITLE, router.locale)}
    >
      <MaxWidth size={SMALL}>
        <Spacing size={SMALL}>
          <SearchInput query={query} setQuery={setQuery} />

          <SearchResultContainer total={results.length} query={query}>
            {resultsForPage.map((data) => (
              <SearchResultItem key={data.href} {...data} />
            ))}
          </SearchResultContainer>
        </Spacing>

        {results.length > SEARCH_RESULTS_PER_PAGE && (
          <Pagination
            current={+router.query.page || 1}
            total={Math.ceil(results.length / SEARCH_RESULTS_PER_PAGE)}
          />
        )}
      </MaxWidth>
    </Page>
  );
};
